<template>
  <Blog :collection="BlogCollection.TECH" />
</template>

<script setup lang="ts">
  import { onMounted, useNuxtApp } from '#imports'

  import { BlogCollection } from '~/constants'

  const { $lenisMount } = useNuxtApp()

  onMounted(() => {
    $lenisMount()
  })
</script>
